import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import { equipmentsListKey } from './useEquipmentsListInfiniteQuery';
import { equipmentsLogListKey } from './useEquipmentsLogListInfiniteQuery';

const equipmentsDeactivateFn = (data: {
  equipments: number[];
  start_date?: string;
  end_date?: string;
  remind_date?: string;
  deactivate_reason?: string;
}) => apiClient.post(`${APP_API_URL}equipments/deactivate`, data);

export const useEquipmentsDeactivateMutation = () => {
  const queryClient = useQueryClient();
  const locationSelectValue = selectAppLocationSelectValue();

  return useMutation({
    mutationFn: equipmentsDeactivateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentsListKey({})[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentsLogListKey({})[0]] });
      }, timeoutDelay);
    },
  });
};
